import 'inputmask';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils.js';

const iti_config = {
  autoHideDialCode: false,
  customPlaceholder: function () {
    return 'Телефон для связи';
  },
  nationalMode: false,
  autoPlaceholder: 'aggressive',
  initialCountry: 'RU',
  onlyCountries: [
    'al',
    'ad',
    'am',
    'at',
    'az',
    'by',
    'be',
    'ba',
    'bg',
    'hr',
    'cz',
    'dk',
    'ee',
    'fo',
    'fi',
    'fr',
    'de',
    'ge',
    'gi',
    'gr',
    'va',
    'hu',
    'is',
    'ie',
    'it',
    'kz',
    'lv',
    'li',
    'lt',
    'lu',
    'mt',
    'md',
    'mc',
    'me',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sm',
    'rs',
    'sk',
    'si',
    'es',
    'se',
    'ch',
    'ua',
    'gb',
    'tr',
  ],
  preferredCountries: ['ru'],
  localizedCountries: {
    al: 'Албания',
    ad: 'Андорра',
    am: 'Армения',
    at: 'Австрия',
    az: 'Азербайджан',
    by: 'Беларусь',
    be: 'Бельгия',
    ba: 'Босния и Герцеговина',
    bg: 'Болгария',
    hr: 'Хорватия',
    cz: 'Чехия',
    dk: 'Дания',
    ee: 'Эстония',
    fo: 'Фарерские острова',
    fi: 'Финляндия',
    fr: 'Франция',
    de: 'Германия',
    ge: 'Грузия',
    gi: 'Гибралтар',
    gr: 'Греция',
    va: 'Ватикан',
    hu: 'Венгрия',
    is: 'Исландия',
    ie: 'Ирландия',
    it: 'Италия',
    kz: 'Казахстан',
    lv: 'Латвия',
    li: 'Лихтенштейн',
    lt: 'Литва',
    lu: 'Люксембург',
    mt: 'Мальта',
    md: 'Молдавия',
    mc: 'Монако',
    me: 'Черногория',
    nl: 'Нидерланды',
    no: 'Норвегия',
    pl: 'Польша',
    pt: 'Португалия',
    ro: 'Румыния',
    ru: 'Россия',
    sm: 'Сан-Марино',
    rs: 'Сербия',
    sk: 'Словакия',
    si: 'Словения',
    es: 'Испания',
    se: 'Швеция',
    ch: 'Швейцария',
    ua: 'Украина',
    gb: 'Великобритания',
    tr: 'Турция',
  },
};

const phone_settings = {
  al: {
    mask: '+355 999 999 999', //12
    validator: /^\+355\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  ad: {
    mask: '+376 999 999', //9
    validator: /^\+376\s[0-9]{3}\s[0-9]{3}$/,
  },
  am: {
    mask: '+374 999 999 999', //12
    validator: /^\+374\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  at: {
    mask: '+43 999 999 9999', //12
    validator: /^\+43\s[0-9]{3}\s[0-9]{3}\s[0-9]{4}$/,
  },
  az: {
    mask: '+\\9\\94 99 999 99 99', //12
    validator: /^\+994\s[0-9]{2}\s[0-9]{3}\s[0-9]{2}\s[0-9]{2}$/,
  },
  by: {
    mask: '+375 99 999 99 99', //12
    validator: /^\+375\s[0-9]{2}\s[0-9]{3}\s[0-9]{2}\s[0-9]{2}$/,
  },
  be: {
    mask: '+32 999 999 999', //11
    validator: /^\+32\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  ba: {
    mask: '+387 99 9999', //9
    validator: /^\+387\s[0-9]{2}\s[0-9]{4}$/,
  },
  bg: {
    mask: '+359 999 999 999', //12
    validator: /^\+359\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  hr: {
    mask: '+385 99 999 999', //11
    validator: /^\+385\s[0-9]{2}\s[0-9]{3}\s[0-9]{3}$/,
  },
  cz: {
    mask: '+420 999 999 999', //12
    validator: /^\+420\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  dk: {
    mask: '+45 99 99 99 99', //10
    validator: /^\+45\s[0-9]{2}\s[0-9]{2}\s[0-9]{2}\s[0-9]{2}$/,
  },
  ee: {
    mask: '+372 9999 9999', //11
    validator: /^\+372\s[0-9]{4}\s[0-9]{4}$/,
  },
  fo: {
    mask: '+298 999 999', //9
    validator: /^\+298\s[0-9]{3}\s[0-9]{3}$/,
  },
  fi: {
    mask: '+358 999 999 99 99', //13
    validator: /^\+358\s[0-9]{3}\s[0-9]{3}\s[0-9]{2}\s[0-9]{2}$/,
  },
  fr: {
    mask: '+33 999 999 999', //11
    validator: /^\+33\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  de: {
    mask: '+49 999 99999999', //13
    validator: /^\+49\s[0-9]{3}\s[0-9]{8}$/,
  },
  ge: {
    mask: '+\\9\\95 999 999 999', //12
    validator: /^\+995\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  gi: {
    mask: '+350 999 99999', //11
    validator: /^\+350\s[0-9]{3}\s[0-9]{5}$/,
  },
  gr: {
    mask: '+30 999 999 9999', //12
    validator: /^\+30\s[0-9]{3}\s[0-9]{3}\s[0-9]{4}$/,
  },
  va: {
    mask: '+39 6 698 99999', //11
    validator: /^\+39\s6\s698\s[0-9]{5}$/,
  },
  hu: {
    mask: '+36 999 999 999', //11
    validator: /^\+36\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  is: {
    mask: '+354 999 9999', //10
    validator: /^\+354\s[0-9]{3}\s[0-9]{4}$/,
  },
  ie: {
    mask: '+353 999 999 999', //12
    validator: /^\+353\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  it: {
    mask: '+39 999 9999 999', //12
    validator: /^\+39\s[0-9]{3}\s[0-9]{4}\s[0-9]{3}$/,
  },
  kz: {
    mask: '+7 799 999 99 99', //11
    validator: /^\+7\s7[0-9]{2}\s[0-9]{3}\s[0-9]{2}\s[0-9]{2}$/,
  },
  lv: {
    mask: '+371 99 999 999', //11
    validator: /^\+371\s[0-9]{2}\s[0-9]{3}\s[0-9]{3}$/,
  },
  li: {
    mask: '+423 999 999 9999', //13
    validator: /^\+423\s[0-9]{3}\s[0-9]{3}\s[0-9]{4}$/,
  },
  lt: {
    mask: '+370 999 99 999', //11
    validator: /^\+370\s[0-9]{3}\s[0-9]{2}\s[0-9]{3}$/,
  },
  lu: {
    mask: '+352 999 999 999', //12
    validator: /^\+352\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  mt: {
    mask: '+356 9999 9999', //11
    validator: /^\+356\s[0-9]{4}\s[0-9]{4}$/,
  },
  md: {
    mask: '+373 9999 9999', //11
    validator: /^\+373\s[0-9]{4}\s[0-9]{4}$/,
  },
  mc: {
    mask: '+377 999 999 999', //12
    validator: /^\+377\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  me: {
    mask: '+382 99 999 999', //11
    validator: /^\+382\s[0-9]{2}\s[0-9]{3}\s[0-9]{3}$/,
  },
  nl: {
    mask: '+31 99 999 9999', //11
    validator: /^\+31\s[0-9]{2}\s[0-9]{3}\s[0-9]{4}$/,
  },
  no: {
    mask: '+47 999 99 999', //10
    validator: /^\+47\s[0-9]{3}\s[0-9]{2}\s[0-9]{3}$/,
  },
  pl: {
    mask: '+48 999 999 999', //11
    validator: /^\+48\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  pt: {
    mask: '+351 99 999 9999', //12
    validator: /^\+351\s[0-9]{2}\s[0-9]{3}\s[0-9]{4}$/,
  },
  ro: {
    mask: '+40 99 999 9999', //11
    validator: /^\+40\s[0-9]{2}\s[0-9]{3}\s[0-9]{4}$/,
  },
  ru: {
    mask: '+7 999 999 99 99[9]', //11-12
    validator: /^\+7\s[0-9]{3}\s[0-9]{3}\s[0-9]{2}\s[0-9]{2}([0-9])?$/,
  },
  sm: {
    mask: '+378 9999 999999', //13
    validator: /^\+378\s[0-9]{4}\s[0-9]{6}$/,
  },
  rs: {
    mask: '+381 99 999 9999', //12
    validator: /^\+381\s[0-9]{2}\s[0-9]{3}\s[0-9]{4}$/,
  },
  sk: {
    mask: '+421 999 999 999', //12
    validator: /^\+421\s[0-9]{3}\s[0-9]{3}\s[0-9]{3}$/,
  },
  si: {
    mask: '+386 99 999 999', //11
    validator: /^\+386\s[0-9]{2}\s[0-9]{3}\s[0-9]{3}$/,
  },
  es: {
    mask: '+34 99 999 999', //10
    validator: /^\+34\s[0-9]{2}\s[0-9]{3}\s[0-9]{3}$/,
  },
  se: {
    mask: '+46 99 999 9999', //11
    validator: /^\+46\s[0-9]{2}\s[0-9]{3}\s[0-9]{4}$/,
  },
  ch: {
    mask: '+41 99 999 9999', //11
    validator: /^\+41\s[0-9]{2}\s[0-9]{3}\s[0-9]{4}$/,
  },
  ua: {
    mask: '+380 99 999 99 99', //12
    validator: /^\+380\s[0-9]{2}\s[0-9]{3}\s[0-9]{2}\s[0-9]{2}$/,
  },
  gb: {
    mask: '+44 99 9999 9999', //12
    validator: /^\+44\s[0-9]{2}\s[0-9]{4}\s[0-9]{4}$/,
  },
  tr: {
    mask: '+\\90 99 9999 9999', //12
    validator: /^\+90\s[0-9]{2}\s[0-9]{4}\s[0-9]{4}$/,
  },
};

function safeInitIntlTelInputs(selector, iti_config) {
  let inputs = document.querySelectorAll(selector);
  if (inputs.length === 0) {
    return;
  }

  inputs.forEach(function (elem) {
    let instance = intlTelInputGlobals.getInstance(elem);
    if (instance) {
      return;
    }
    let iti = intlTelInput(elem, iti_config);

    let initial_mask = phone_settings[iti.getSelectedCountryData().iso2]['mask'];
    Inputmask(initial_mask).mask(`${elem.id}`);
    elem.addEventListener('countrychange', function () {
      let mask = phone_settings[iti.getSelectedCountryData().iso2]['mask'];

      Inputmask.setValue(`${elem.id}`, '');
      Inputmask(mask).mask(`${elem.id}`);
    });
  });
}

function safeInitIntlTelInput(selector, iti_config) {
  let input = document.querySelector(selector);
  let instance = intlTelInputGlobals.getInstance(input);
  if (instance) {
    return;
  }
  let iti = intlTelInput(input, iti_config);

  let initial_mask = phone_settings[iti.getSelectedCountryData().iso2]['mask'];
  Inputmask(initial_mask).mask(selector);
  input.addEventListener('countrychange', function () {
    let mask = phone_settings[iti.getSelectedCountryData().iso2]['mask'];

    Inputmask.setValue(selector, '');
    Inputmask(mask).mask(selector);
  });

  return iti;
}

export { iti_config, phone_settings, safeInitIntlTelInput, safeInitIntlTelInputs };
